import { render, staticRenderFns } from "./Edtaddress.vue?vue&type=template&id=f85062a8&scoped=true&"
import script from "./Edtaddress.vue?vue&type=script&lang=js&"
export * from "./Edtaddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85062a8",
  null
  
)

export default component.exports